import { WPS_ThicknessTable } from "./WPS_ThicknessTable";

export const WPS_Thickness_Groove = ({ headerObj, error, isReadonly, handleChange, setError }) => {
  const rows = [
    { label: 'Groove without Impact', minField: 'WPSH_TRQ_GroovewithoutImpact_Min', maxField: 'WPSH_TRQ_GroovewithoutImpact_Max' },
    { label: 'Groove with Impact', minField: 'WPSH_TRQ_GroovewithImpact_Min', maxField: 'WPSH_TRQ_GroovewithImpact_Max' },
    { label: 'Fillet without Impact', minField: 'WPSH_TRQ_FilletwithoutImpact_Min', maxField: 'WPSH_TRQ_FilletwithoutImpact_Max' },
    { label: 'Fillet with Impact', minField: 'WPSH_TRQ_FilletwithImpact_Min', maxField: 'WPSH_TRQ_FilletwithImpact_Max' }
  ];

  return (
    <WPS_ThicknessTable
      headerObj={headerObj}
      error={error}
      isReadonly={isReadonly}
      handleChange={handleChange}
      setError={setError}
      rows={rows}
    />
  );
};